import { render, staticRenderFns } from "./PrivateKeysForm.vue?vue&type=template&id=953dc5e0&"
import script from "./PrivateKeysForm.vue?vue&type=script&lang=js&"
export * from "./PrivateKeysForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953dc5e0')) {
      api.createRecord('953dc5e0', component.options)
    } else {
      api.reload('953dc5e0', component.options)
    }
    module.hot.accept("./PrivateKeysForm.vue?vue&type=template&id=953dc5e0&", function () {
      api.rerender('953dc5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/PrivateKeysForm.vue"
export default component.exports